{
  "screen": {
    "overline": "ON-DEMAND LIBRARY",
    "overlineFavorites": "YOUR COLLECTION",
    "title": "Explore Practices",
    "titleFavorites": "Your Favorites",
    "subtitle": "A curated archive of recorded sessions, guided practices, and transformative teachings. Find your flow, anytime, anywhere.",
    "subtitleFavorites": "All the sessions you've saved for later. Pick up where you left off.",
    "searchPlaceholder": "Search by title, master, or practice...",
    "recordings": "Recordings",
    "practicesTab": "Practices",
    "all": "All",
    "signInFavorites": "Sign In to See Favorites",
    "signInFavoritesHint": "Create an account to save your favorite sessions and access them anytime.",
    "loadingFavorites": "Loading your favorites...",
    "noFavorites": "No Favorites Yet",
    "noFavoritesHint": "Browse recordings and practices, then tap the heart icon to save them here.",
    "itemsSaved": "{{count}} ITEM SAVED",
    "itemsSaved_plural": "{{count}} ITEMS SAVED",
    "loadingRecordings": "Loading recordings...",
    "loadingPractices": "Loading practices...",
    "browseLibrary": "BROWSE LIBRARY",
    "signIn": "SIGN IN",
    "retry": "Retry"
  },
  "sort": {
    "newest": "Newest",
    "oldest": "Oldest",
    "shortest": "Shortest",
    "longest": "Longest"
  },
  "duration": {
    "short": "Short",
    "daily": "Daily",
    "standard": "Standard",
    "long": "Long"
  },
  "categories": {
    "all": "All",
    "yogaMovement": "Yoga & Movement",
    "meditation": "Meditation",
    "buddhism": "Buddhism",
    "shaivism": "Shaivism",
    "psychology": "Psychology",
    "wellness": "Wellness",
    "breathwork": "Breathwork",
    "dailyRituals": "Daily Rituals"
  },
  "badges": {
    "recording": "RECORDING",
    "video": "VIDEO",
    "practice": "PRACTICE",
    "watched": "WATCHED"
  },
  "detail": {
    "loading": "Preparing your session...",
    "unavailable": "Session Unavailable",
    "unavailableHint": "We couldn't load this practice session.",
    "streamUnavailable": "This session's stream is currently unavailable.",
    "sharePractice": "SHARE PRACTICE",
    "linkCopied": "LINK COPIED!",
    "guidedBy": "GUIDED BY",
    "inFavorites": "IN FAVORITES",
    "addToFavorites": "ADD TO FAVORITES",
    "original": "Original",
    "translate": "Translate",
    "chooseLanguage": "Choose Language",
    "searchLanguages": "Search languages...",
    "noLanguagesMatch": "No languages match your search",
    "noLanguages": "No additional languages available",
    "queued": "Queued",
    "queuedHint": "Translation is being prepared",
    "translating": "Translating... {{percent}}%",
    "preparingAudio": "Preparing audio... ~{{seconds}}s",
    "listenNow": "LISTEN NOW",
    "pause": "PAUSE",
    "play": "PLAY",
    "translationFailed": "Translation failed",
    "videoWebOnly": "Video playback is only available on web",
    "videoUnavailable": "This video is unavailable right now. We're on it — check back a little later",
    "seekUnavailable": "Rewinding isn't available for this video",
    "audioWebOnly": "Audio playback is only available on web",
    "audioOnly": "Audio only",
    "publishedAt": "PUBLISHED {{date}}",
    "at": "at ",
    "recording": "Recording",
    "video": "Video",
    "practice": "Practice",
    "audio": "Audio"
  },
  "sidebar": {
    "myLibrary": "My Library",
    "favorites": "FAVORITES",
    "upcomingLives": "UPCOMING LIVE SESSIONS",
    "archive": "ARCHIVE",
    "noFavorites": "No favorites yet",
    "noUpcoming": "No upcoming live sessions",
    "noPast": "No past live sessions",
    "share": "Share",
    "repost": "Repost",
    "delete": "Delete",
    "repostSuccess": "{{title}} has been added to your profile.",
    "deleteConfirm": "Delete {{title}} from archive?"
  },
  "share": {
    "subject": "«{{title}}» — a practice on Agapella",
    "message": "«{{title}}» — a practice on Agapella\n{{url}}"
  },
  "native": {
    "all": "All practices",
    "loadMore": "Load more",
    "empty": "Nothing found",
    "emptyHint": "Try other words or remove some of the filters.",
    "errorHint": "Check your connection and try again.",
    "clearFilters": "Clear filters",
    "loadFailed": "Couldn't load practices",
    "signInToSave": "Sign in to save practices",
    "library": "My library",
    "hero": {
      "title": "Practise together",
      "subtitle": "Create a live session and invite friends — you can choose the practice inside.",
      "cta": "Create a live session",
      "ctaA11y": "Create a quick live session"
    },
    "count_one": "{{count}} practice",
    "count_other": "{{count}} practices",
    "libraryScreen": {
      "title": "My library",
      "subtitle": "Favourites, playlists, watch history and your content.",
      "playlists": "Playlists",
      "favorites": "Favourites",
      "recent": "Recent",
      "newPlaylist": "New playlist",
      "yourContent": "Your content",
      "playlistName": "Playlist name",
      "create": "Create",
      "pickHint": "Tick practices to add them to the playlist."
    },
    "collection": {
      "title": "My collection",
      "subtitle": "Your favourite practices, events, masters and materials in one place.",
      "saved_one": "{{count}} saved item",
      "saved_other": "{{count}} saved items",
      "seeAll": "See all",
      "all": "All",
      "practices": "Practices",
      "events": "Events",
      "masters": "Masters",
      "media": "Media",
      "empty": "Nothing in favourites yet"
    },
    "sortTitle": "Sort",
    "sort": {
      "newest": "Newest first",
      "oldest": "Oldest first",
      "duration_asc": "Shortest first",
      "duration_desc": "Longest first"
    },
    "sortSheetNewest": "By newest",
    "pickMaster": "Choose a master",
    "clearMasterA11y": "Clear the master filter",
    "searchA11y": "Search practices",
    "searchPlaceholder": "Search practices…",
    "clearSearchA11y": "Clear search",
    "searchResults": {
      "showAll": "Show all ({{count}})",
      "empty": "Nothing found for “{{query}}”",
      "loading": "Searching…",
      "failed": "Search failed"
    },
    "searchApplied": {
      "label": "Search: “{{query}}”",
      "clearA11y": "Reset search “{{query}}”"
    },
    "report": "Report",
    "audioPractice": "Audio practice",
    "practice": "Practice",
    "moreActions": "More actions",
    "startPracticeA11y": "Start practice: {{title}}",
    "startPractice": "Start practice",
    "findMasterPlaceholder": "Find a master by name",
    "noMastersFound": "No masters found",
    "libraryLoadFailed": "Couldn't load your saved items. Try again later.",
    "libraryEmpty": "Everything you mark with a heart will show up here.",
    "helper": {
      "name": "Agapella",
      "title": "Didn't find\nthe right practice?",
      "copy": "Tell us how you feel, and the AI will pick a practice in a minute.",
      "badge": "AI assistant",
      "cta": "Find with AI"
    },
    "collectionFallback": "Collection",
    "collectionEmpty": "This collection has no practices yet.",
    "participantsCount_one": "{{count}} participant",
    "participantsCount_other": "{{count}} participants",
    "nowSoon": {
      "title": "Now and upcoming",
      "subtitle": "Live and upcoming sessions.",
      "seeAll": "All live sessions",
      "status": {
        "live": "Now",
        "soon": "Soon",
        "open": "Open"
      },
      "own": "Yours",
      "kind": {
        "video": "Video",
        "audio": "Audio",
        "ambient": "Ambient"
      },
      "join": "Join",
      "enter": "Enter",
      "share": "Share",
      "going": "Going",
      "shareA11y": "Share: {{title}}"
    },
    "collections": {
      "title": "Collections",
      "fallback": {
        "morning": "Morning practices",
        "presence": "Presence practices",
        "evening": "Evening relaxation",
        "energy": "Energy for every day"
      }
    },
    "heroArt": {
      "a11yDark": "Night landscape, mountains and a lotus",
      "a11yLight": "Sunrise, mountains and a lotus",
      "title": "Find what will support you today.",
      "subtitle": "Practices for inner balance, clarity, energy and gentle attention to yourself."
    },
    "detail": {
      "signInToSave": "Sign in to add this practice to favorites",
      "notFound": "Practice not found",
      "videoFailed": "The video didn't load. Check your connection and open the practice again.",
      "publishedDate": "{{date}}, {{year}}",
      "inFavorites": "In favorites",
      "addToFavorites": "Add to favorites",
      "description": "Description",
      "discussion": "Discussion",
      "discussionHint": "Share what resonated with you.",
      "discussionA11y": "Discussion, messages: {{count}}",
      "discussionBack": "Back to the practice",
      "plannedLivePractices": "Scheduled Live practices",
      "participantsShort": "{{count}} p."
    }
  }
}
